import { IBaseApiRequest, IFilterByCustomer } from '@api';
import { AxiosResponse } from 'axios';

interface IGetAll extends IBaseApiRequest, IFilterByCustomer {
  filterType: string;
}
export async function getAll({ api, filterType, baasClientId }: IGetAll) {
  let response = (await api.get(`v1/${baasClientId}/filters`, {
    params: {
      filterType,
    },
  })) as AxiosResponse<{
    data: Array<{ key: string; values: string[] }>;
  }>;

  return response.data?.data;
}
